import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "disbursements-wrapper" }

import type { CertificationModelVM } from "@/models/certificationService";
import type {
  DisbursementModelVM,
  DisbursementSummaryItemModel,
} from "@/models/disbursementService";
import { computed } from "vue";
import DisbursementSummaryItem from "./DisbursementSummaryItem.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Disbursements',
  props: {
    certification: {},
    disbursements: {}
  },
  setup(__props: any) {

const props = __props;

const disbursementSummary = (disbursement: DisbursementModelVM) => {
  return `${disbursement?.estimatedDisbursementDate} | ${disbursement?.disbursementAmount} | ${disbursement?.details?.status}`;
};

const disbursementHeader = (index: number) => {
  return `Disbursement ${index + 1}`;
};

const disbursementSummaries = computed<DisbursementSummaryItemModel[]>(() => {
  if (props.disbursements && props.disbursements?.length > 0) {
    return props.disbursements.map((d: DisbursementModelVM, index: number) => {
      return {
        id: `Cert${index}${d.sequenceNumber}`,
        header: disbursementHeader(index),
        details: disbursementSummary(d),
      };
    });
  }

  return [];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(disbursementSummaries.value, (d) => {
        return (_openBlock(), _createBlock(DisbursementSummaryItem, {
          key: d.id,
          header: d.header,
          details: d.details
        }, null, 8, ["header", "details"]))
      }), 128))
    ])
  ]))
}
}

})